import { memo } from "react";
import { styled } from "styled-components";

import { ListItemWrapper } from "common/components/lists/ListItemWrapper";
import { ListImage, ListLink } from "common/components/lists/ListLink";
import { breakWordStyle, lineTruncationStyle } from "common/styles";
import type { Initiative } from "entities/initiatives/types";

const StyledListLink = styled(ListLink)`
  display: flex;
  align-items: center;
`;

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 1rem;
  margin: 0 0 0.5rem;

  ${breakWordStyle}
  ${lineTruncationStyle(2)}
`;

const StyledImage = styled(ListImage)`
  border-radius: 4px;
  margin-right: 1rem;
  height: 64px;
  width: 64px;
  min-width: 64px;
`;

type InitiativeListItemProps = { initiative: Initiative; isSelected?: boolean; link: string; onClick?: () => void };

export const InitiativeListItem = memo(({ isSelected = false, link, onClick, initiative }: InitiativeListItemProps) => (
  <ListItemWrapper trackPage="Discover" isLocked={false} isSelected={isSelected}>
    <StyledListLink to={link} onClick={onClick}>
      <StyledImage src={initiative.images?.thumbnail} />
      <div>
        <StyledTitle>{initiative.name}</StyledTitle>
      </div>
    </StyledListLink>
  </ListItemWrapper>
));

InitiativeListItem.displayName = "InitiativeListItem";
